// 1.0 DEFINE CONST
const _document = $(document);
const _window = $(window);

const html = $('html');
const body = $('body');

let responsive = 900 < innerWidth ? false : true;
let responsiveMobile = 600 < innerWidth ? false : true;

const initResponsive = () => {
	responsive = 900 < innerWidth ? false : true;
	responsiveMobile = 600 < innerWidth ? false : true;
};
_window.on('resize', initResponsive);

keyOnPress = false;
_document
	.on('keydown', function () {
		keyOnPress = true;
	})
	.on('keyup', function () {
		keyOnPress = false;
	});

tabActive = true;
_window
	.focus(function () {
		tabActive = true;
		html.addClass('tab_active');
	})
	.blur(function () {
		tabActive = false;
		html.removeClass('tab_active');
	});

// 2.0 UTILITY FUNCTIONS

// Function to handle lazy-loaded images
const lazyImages = document.querySelectorAll('img[loading="lazy"]');

const handleLazyImages = (img) => {
	if (img.complete) {
		img.classList.add('is-loaded');
	} else {
		img.addEventListener('load', () => {
			img.classList.add('is-loaded');
		});
	}
};

// Use IntersectionObserver to detect images entering the viewport
const lazyImageObserver = new IntersectionObserver((entries, observer) => {
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			const img = entry.target;

			// Handle the image loading
			handleLazyImages(img);

			// Stop observing the image once it's handled
			observer.unobserve(img);
		}
	});
});

lazyImages.forEach((img) => {
	lazyImageObserver.observe(img);
});

// Use MutationObserver to detect new images added to the DOM
const observer = new MutationObserver((mutations) => {
	mutations.forEach((mutation) => {
		mutation.addedNodes.forEach((node) => {
			if (node.tagName === 'IMG' && node.getAttribute('loading') === 'lazy') {
				lazyImageObserver.observe(node);
			}
		});
	});
});

// Start observing the document for changes
observer.observe(document.body, { childList: true, subtree: true });

const initForms = () => {
	let inputs = $(`.field input[type="text"],
		.field input[type="email"],
		.field input[type="tel"],
		.field input[type="url"],
		.field input[type="password"],
		.field textarea`);

	inputs
		.each(function () {
			let _this = $(this);

			if (_this.val().length > 0) {
				_this.closest('.field').addClass('has_value');
			}
		})
		.blur(function () {
			let _this = $(this);

			_this.val()
				? _this.closest('.field').addClass('has_value')
				: _this.closest('.field').removeClass('has_value');
		});
};

const initAccessibility = () => {
	const buttons = $('button, .button');
	buttons.each(function () {
		let button = $(this);
		button.attr('role', 'button');

		if (button.hasClass('cart-item-increase') && button.hasClass('plus')) {
			button.attr('aria-label', 'Increase quantity');
		}
		if (button.hasClass('cart-item-decrease') && button.hasClass('minus')) {
			button.attr('aria-label', 'Decrease quantity');
		}
		if (button.hasClass('btn-x')) {
			button.attr('aria-label', 'Exit');
		}
		if (button.hasClass('btn-next')) {
			button.attr('aria-label', 'View next item');
		}
		if (button.hasClass('btn-prev')) {
			button.attr('aria-label', 'View previous item');
		}
	});

	// avoid focus styling on click
	// desktop only
	if (!responsive) {
		let mouseDown = false;
		_document
			.mousedown(function () {
				mouseDown = true;
			})
			.mouseup(function () {
				mouseDown = false;
			});

		_document.on('focusin', (e) => {
			if (e.target.tagName != 'INPUT' && e.target.tagName != 'TEXTAREA') {
				if (mouseDown) {
					e.target.blur();
				}
			}
		});
	}

	const dropdowns = $(
		'#product-panel .custom-input, #product-sticky-container .custom-input'
	);

	dropdowns.each(function () {
		let dropdown = $(this);
		dropdown.attr('role', 'button');
		// makes it focusable
		dropdown.attr('tabindex', 0);
	});
};

const scrollToEl = (id, offset) => {
	let scrollPosition = $(id).offset().top - offset;

	$('html, body').animate(
		{
			scrollTop: scrollPosition,
			// 300 ms to scroll through one window height
		},
		(scrollPosition / innerHeight) * 300
	);
};

const download = () => {
	_document.on('click', '[data-action="download"]', function () {
		window.print();
	});
};

const formatCommify = (value) => {
	return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

// 3.0 GLOBAL FUNCTIONS

const initPageTransition = () => {
	document.querySelectorAll('a[href]').forEach((item) => {
		// if href points to anchor, or points to anchor that exists on page
		if (
			(item.href.includes(siteUrl) && item.href.includes('#')) ||
			item.href.startsWith('#')
		) {
			item.setAttribute('data-page-transition', 'scroll');
		} else if (
			(item.href.includes(siteUrl) || item.href.startsWith('/')) &&
			item.target != '_blank' &&
			!item.href.includes('mailto:')
		) {
			item.setAttribute('data-page-transition', 'internal');
		} else {
			item.rel = 'noopener';
			item.target = item.target || '_blank';
			item.setAttribute(
				'aria-label',
				`External link in a new tab to ${item.href.split('?')[0]}`
			);
		}
	});

	on('body', 'click', 'a[href]', (e) => {
		let target = e.target.closest('[data-page-transition]') || e.target;

		target.blur();

		if (
			target.dataset.pageTransition == 'internal' &&
			!root.classList.contains('key-is-down')
		) {
			e.preventDefault();
			root.classList.remove('cart_active', 'menu_open');
			root.classList.add('is_leaving');

			setTimeout(() => {
				location.href = target.href;
			}, 300);
		} else if (target.dataset.pageTransition == 'scroll') {
			e.preventDefault();
			const id = target.href.split('#')[1];
			if (id) {
				document.getElementById(id).scrollIntoView({
					behavior: 'smooth',
				});
			}
		}
	});

	window.addEventListener('keydown', () => {
		root.classList.add('key-is-down');
	});

	window.addEventListener('keyup', () => {
		root.classList.remove('key-is-down');
	});
};

const initSlideshow = () => {
	const slider = $('.custom-slider');
	if (slider.length > 0) {
		const speed = parseInt(slider.data('speed'));
		const slides = slider.find('.slide');
		const count = slides.length;
		slides.first().addClass('active');
		setInterval(function () {
			let activeSlide = slider.find('.slide.active');
			let index = activeSlide.index();
			if (index == count - 1) {
				activeSlide.removeClass('active');
				slides.first().addClass('active');
			} else {
				activeSlide.removeClass('active').next().addClass('active');
			}
		}, speed);
	}
};

const initPageAnimation = () => {
	document.querySelectorAll('[data-ani-anchor]').forEach((item) => {
		let observer = new IntersectionObserver(
			(el) => {
				const object = el[0];
				const target = object.target;

				if (object.isIntersecting && !target.classList.contains('animate')) {
					target.classList.add('animate');
				}
			},
			{
				root: null,
				threshold: [0.3], // 0 = page start; 1 = page bottom, items only revealed when in full view
			}
		);

		observer.observe(item);
	});
};

const initNav = () => {
	const flyout = document.getElementById('menu-flyout');
	// attempt to future-proof this nav link
	// by keeping selector broad
	const nav = document.getElementById('menu');
	const flyoutTrigger = document.querySelector('#menu a[data-hash]');
	const flyoutExit = flyout.querySelector('.btn-x');
	const flyoutBackdrop = document.getElementById('menu-flyout-backdrop');
	const flyoutLeft = document.getElementById('menu-flyout-left');
	const flyoutMiddle = document.getElementById('menu-flyout-middle');
	const flyoutLeftLinks = flyoutLeft.querySelectorAll('a');
	const flyoutMiddleLinkGroups =
		flyoutMiddle.querySelectorAll('.menu-middle-group');
	const flyoutMiddleLinks = flyoutMiddle.querySelectorAll('a');
	const flyoutRight = document.getElementById('menu-flyout-right');
	const flyoutLinks = flyout.querySelectorAll('a');

	// first step: open the flyout menu on header link click
	const processNav = (target, trigger) => {
		let show = true;
		target.addEventListener('mouseleav', () => {
			show = false;
		});

		setTimeout(() => {
			if (show) {
				// only run if the flyout isn't already open
				if (!html.hasClass('menu_open')) {
					if (flyoutRight.dataset.bg) {
						flyoutRight.style.background = `url(${flyoutRight.dataset.bg}) no-repeat center center`;
						delete flyoutRight.dataset.bg;
					}
					html.addClass('menu_open');
				}

				// focus on first item/link
				if (trigger == 'focus') {
					setTimeout(function () {
						flyout.querySelector('a').focus();
					}, 800);
					html.addClass('nav_tab');
				} else {
					html.removeClass('nav_tab');
				}
			}
		}, 10);
	};

	const closeFlyouts = () => {
		html.removeClass('menu_open');
		html.removeClass('nav_tab');
		// remove secondary active states once menu is out of view
		setTimeout(function () {
			html.removeClass('menu_middle_open');
			flyoutLinks.forEach((link) => {
				link.classList.remove('active');
			});
			flyoutMiddleLinkGroups.forEach((group) => {
				group.classList.remove('active');
			});
			flyoutRight.innerHTML = '';
		}, 600);
	};

	// close menu on escape
	_document.keyup(function (e) {
		if (e.key === 'Escape') {
			closeFlyouts();
		}
	});

	// close menu on button click
	flyoutExit.addEventListener('click', () => {
		closeFlyouts();
	});

	// close menu on backdrop click
	flyoutBackdrop.addEventListener('click', () => {
		closeFlyouts();
	});

	// on desktop, close nav when user is mousing elsewhere
	if (!responsive) {
		// remove flyout on menu main focus
		document.getElementById('main').addEventListener('focus', (e) => {
			closeFlyouts();
		});

		// remove flyout on 1s of background hover
		// but not if the user is using tabs (ADA)
		let show = true;

		const closeFlyoutWithDelay = () => {
			show = true;
			if (!html.hasClass('nav_tab')) {
				setTimeout(() => {
					if (show) {
						closeFlyouts();
					}
				}, 1000);
			}
		};

		// remove flyout on menu or backdrop hover
		flyoutBackdrop.addEventListener('mouseenter', (e) => {
			closeFlyoutWithDelay();
		});
		nav.addEventListener('mouseover', (e) => {
			closeFlyoutWithDelay();
		});

		// reset timer if panel or trigger is hovered
		flyout.addEventListener('mouseenter', (e) => {
			show = false;
		});
		flyoutTrigger.addEventListener('mouseenter', (e) => {
			show = false;
		});
	}

	// second step: show/hide middle panel links
	const processFlyoutLinks = (parentLink) => {
		let show = true;
		parentLink.addEventListener('mouseleave', () => {
			show = false;
		});

		setTimeout(() => {
			if (show) {
				let linkHandle = parentLink.dataset.linkHandle;

				//reset active states on left-hand links
				flyoutLeftLinks.forEach((link) => {
					link.classList.remove('active');
				});

				// if this link group corresponds to the hovered parent link
				let matchedGroup =
					document.querySelector(
						`.menu-middle-group[data-link-handle="${linkHandle}"]`
					) || '';

				// if there's a match, show the matched links
				if (matchedGroup) {
					//reset active states on left-hand links
					parentLink.classList.add('active');

					// if the match is not already active, clear the product feature
					// we wouldn't want to show a pasta product when the pizza panel is open, for instance
					if (!matchedGroup.classList.contains('active')) {
						flyoutRight.innerHTML = '';
						flyoutMiddleLinks.forEach((link) => {
							link.classList.remove('active');
						});
					}

					// let groupHandle = matchedGroup.data('link-handle');

					// activate the middle panel for animation
					if (!html.hasClass('menu_middle_open')) {
						html.addClass('menu_middle_open');
					}

					setTimeout(() => {
						flyoutMiddleLinkGroups.forEach((group) => {
							group.classList.remove('active');
						});
						matchedGroup.classList.add('active');
					}, 400);
				} else {
					html.removeClass('menu_middle_open');
					flyoutMiddleLinks.forEach((link) => {
						link.classList.remove('active');
					});
					flyoutRight.innerHTML = '';
					flyoutMiddleLinkGroups.forEach((link) => {
						link.classList.remove('active');
					});
				}
			}
		}, 300);
	};

	const buildFeature = (link) => {
		productHTML = `<div class="menu-product fh fc ani-fadein ${link[0]['available']}">
			<a href="${link[0]['url']}" class="image-wrapper contain">
				<img class="mix" src="${link[0]['image']}" alt="${link[0]['title']}">
			</a>
			<div class="product-info fv fsb">
				<div class="mb15">
					<a href="${link[0]['url']}" class="t-heading-small"><p class="mb15">${link[0]['title']}</p></a>
					<div class="t-body-small mb15">${link[0]['description']}</div>
					<a href="${link[0]['url']}" class="t-label hover-line active">More information</a>
				</div>
				<div>
					<p class="t-label">Free Shipping!</p>
					<div class="product-value mb15">
		        <span class="product-size">${link[0]['size']} ${link[0]['pack']}</span>
		        <span>&nbsp;|&nbsp;</span>
		        <span class="product-price">${link[0]['price']}</span>
		      </div>
					<div class="product-actions fh fs w-xs">
						<a href="${link[0]['url']}" class="btn" aria-label="Go to product page">Learn More</a>
						<a href="/pages/store-locator" class="where-to-buy btn bg-cream" onclick="ga('send','event','Link','Click','Find in Store Locator')">Where to Buy</a>
					</div>
				</div>
			</div>
		</div>`;
	};

	const processFlyoutFeature = (target) => {
		let show = true;
		target.addEventListener('mouseleave', () => {
			show = false;
		});

		setTimeout(() => {
			if (show) {
				let linkHandle = target.dataset.childHandle;

				flyoutMiddleLinks.forEach((link) => {
					link.classList.remove('active');
				});
				target.classList.add('active');

				let match = menuHTML.filter((link) => {
					return link.linkHandle == linkHandle;
				});

				buildFeature(match);
				flyoutRight.innerHTML = productHTML;
			}
		}, 300);
	};

	// prevent # scroll up and appending of # to URL
	flyoutTrigger?.addEventListener('click', (e) => {
		e.preventDefault();
	});

	// this is only for desktop
	if (!responsive) {
		flyoutTrigger?.addEventListener('mouseenter', (e) => {
			e.preventDefault();
			let target = e.target;
			processNav(target, 'mouse');
		});

		flyoutTrigger?.addEventListener('focus', (e) => {
			e.preventDefault();
			let target = e.target;
			processNav(target, 'focus');
		});

		// toggle middle links
		flyoutLeftLinks.forEach((link) => {
			link.addEventListener('mouseenter', (e) => {
				e.preventDefault();
				let target = e.target;
				processFlyoutLinks(target);
			});
		});

		// swap product features
		flyoutMiddleLinks.forEach((link) => {
			link.addEventListener('mouseenter', (e) => {
				e.preventDefault();
				let target = e.target;
				processFlyoutFeature(target);
			});
		});
	}
};

const initMobileNav = () => {
	const mobileNav = $('#mobile-menu');
	const mobileNavTrigger = $('#mobile-nav-trigger');
	const mobileNavBack = mobileNav.find('.btn-prev');
	const mobileShopLevel1 = $('#mobile-menu-shop-1');
	const mobileShopLevel1Links = mobileShopLevel1.find('a');
	const mobileNavLevel2 = $('#mobile-menu-shop-2');
	const mobileShopGroups = $('.mobile-shop-group');

	// second step: show/hide middle panel links
	on('body', 'click', '#mobile-menu-shop-1 a', (e) => {
		let _this = e.target.closest('a');
		let linkHandle = _this.dataset.linkHandle;

		// if this link group corresponds to the hovered parent link
		let matchedGroup =
			$(`.mobile-shop-group[data-link-handle="${linkHandle}"]`).length > 0
				? $(`.mobile-shop-group[data-link-handle="${linkHandle}"]`)
				: '';

		// if there's a match, show the matched links
		if (matchedGroup != '') {
			e.preventDefault();
			e.stopImmediatePropagation();

			let groupHandle = matchedGroup.data('link-handle');

			// activate the middle panel for animation
			if (!html.hasClass('menu_mobile_level2')) {
				html.addClass('menu_mobile_level2');
			}

			matchedGroup.addClass('active');
			matchedGroup.siblings().removeClass('active');
		}
	});

	const closeMobileNav = () => {
		html.removeClass('mobile_nav_active');
		html.removeClass('menu_mobile_level2');
		mobileShopGroups.removeClass('active');
	};

	mobileNavBack.click(function (e) {
		html.removeClass('menu_mobile_level2');
		mobileShopGroups.removeClass('active');
	});

	// toggle nav
	mobileNavTrigger.click(function (e) {
		if (html.hasClass('mobile_nav_active')) {
			closeMobileNav();
			scrollEnable();
		} else {
			html.addClass('mobile_nav_active');
			scrollDisable();
			// if cart is open, close it
			if (html.hasClass('cart_active')) {
				$('#menu .cart-trigger').trigger('click');
			}
		}
	});
};

const initCart = () => {
	const cart = $('#cart');
	const menuCart = $('#menu-cart');
	const cartTriggerMenu = $('#menu .cart-trigger');
	const cartTrigger = $('.cart-trigger');
	const cartTotal = cart.find('#cart-total');
	const cartItemCount = cartTrigger.find('#cart-item-count');
	let lastFocusedElement = null;

	const itemUpdate = (item, qty) => {
		$.post(`/cart/update.js?updates[${item.data('item-id')}]=${qty}`);
		if (qty == 0) {
			item.remove();
		}
	};

	const cartTotalUpdate = () => {
		cartTotalPrice = 0;
		cartTotalItemCount = 0;

		// loop through each item
		$('.cart-item').each(function () {
			let _this = $(this);
			let thisQuantity = parseInt(_this.find('.item-quantity-current').text());
			let thisPlural = _this.find('.plural');

			thisQuantity > 1
				? thisPlural.addClass('active')
				: thisPlural.removeClass('active');

			// multiply price and quantity, and add to total value
			cartTotalPrice +=
				parseFloat(_this.data('item-price')) *
				parseInt(_this.find('.item-quantity-current').text());
			cartTotalItemCount += thisQuantity;
		});

		// update cart total values
		cartTotal.text('$' + cartTotalPrice.toFixed(2));
		cartItemCount.text(cartTotalItemCount);
		cart.attr('data-cart-count', cartTotalItemCount);
		menuCart.attr('data-cart-count', cartTotalItemCount);
	};

	const cartButtonUpdate = (button) => {
		// signal update within CTA text
		const cta = button.find('.cart-submit-text');
		const defaultText = cta.text();

		// temporarily change button text to "added"
		if (cta.length) {
			cta.text('Added!');
			setTimeout(function () {
				cta.text(defaultText);
			}, 2000);
		}

		// trigger cart animation
		cart.addClass('added');
		setTimeout(function () {
			cart.removeClass('added');
		}, 2000);
	};

	const closeCartAndReturnFocus = () => {
		html.removeClass('cart_active');
		history.pushState(null, null, ' ');

		if (lastFocusedElement) {
			lastFocusedElement.focus();
			lastFocusedElement = null;
		}
	};

	// cart open
	cartTrigger.click(function () {
		// store the currently focused element before opening the cart
		if (!html.hasClass('cart_active')) {
			lastFocusedElement = $(document.activeElement);
		}

		html.toggleClass('cart_active');

		if (!html.hasClass('cart_active')) {
			history.pushState(null, null, ' ');
			// if closing via cart trigger, return focus
			if (lastFocusedElement) {
				lastFocusedElement.focus();
				lastFocusedElement = null;
			}
		} else {
			window.location.hash = '#cart';
			// if mobile menu is open, close it
			if (html.hasClass('mobile_nav_active')) {
				$('#mobile-nav-trigger').trigger('click');
			}
			// focusing the cart element itself or the first tabbable element inside
			cart.find('.cart-trigger').focus();
		}
	});

	// cart close
	$('#cart-overlay').click(function () {
		closeCartAndReturnFocus();
	});

	// close cart on ESC key press
	$(document).on('keydown', function (e) {
		if (e.key === 'Escape' && html.hasClass('cart_active')) {
			e.preventDefault();
			closeCartAndReturnFocus();
		}
	});

	// cart add submissions
	_document.on('submit', 'form[action="/cart/add"]', function (e) {
		let _this = $(this);
		e.preventDefault();
		$.ajax({
			type: 'POST',
			url: '/cart/add.js',
			data: $(this).serialize(),
			dataType: 'json',
			error: function (data) {
				alert("Can't add this product to cart!");
			},
		}).done(function (data) {
			$.ajax({
				url: '/cart',
				dataType: 'html',
				error: function (data) {
					console.error(data);
				},
				success: function (data) {
					$('#cart-items').html($(data).find('#cart-items-fetch').html());
					cartTotalUpdate();
					cartButtonUpdate(_this);
					cartTriggerMenu.trigger('click');
					ttq.track('AddToCart');
				},
			});
		});
	});

	// item quantity adjustments
	_document.on('click', '.item-quantity button', function () {
		let _this = $(this);
		let cartItem = _this.closest('.cart-item');
		let quantityMax = cartItem.attr('data-inventory-max');
		let quantityCurrent = cartItem.find('.item-quantity-current');
		let quantityCurrentVal = parseInt(quantityCurrent.text());
		let quantityAction = _this.hasClass('item-quantity-increase')
			? 'increase'
			: 'decrease';

		// if increase, and isn't max inventory count
		let quantityNewVal =
			quantityAction == 'increase' && quantityCurrentVal <= quantityMax
				? // increase quantity
					quantityCurrentVal + 1
				: // else if is decrease and quantity isn't 0
					quantityAction == 'decrease' && quantityCurrentVal > 0
					? // decrease quantity
						quantityCurrentVal - 1
					: // else, stay at current quantity
						quantityCurrentVal;

		// update quantity text
		quantityCurrent.text(quantityNewVal);

		// trigger ajax update
		itemUpdate(cartItem, quantityNewVal);

		// update total pricing
		cartTotalUpdate();
	});

	// item quantity adjustments
	_document.on('click', '.item-remove', function () {
		let _this = $(this);
		let cartItem = _this.closest('.cart-item');
		let quantityCurrent = _this
			.closest('.item-info')
			.find('.item-quantity-current');
		let quantityCurrentVal = parseInt(quantityCurrent.text());

		// if increase, and isn't max inventory count
		let quantityNewVal = 0;

		// update quantity text
		quantityCurrent.text(quantityNewVal);

		// trigger ajax update
		itemUpdate(cartItem, quantityNewVal);

		// update total pricing
		cartTotalUpdate();
	});

	// cart page redirect
	if (window.location.hash == '#cart') {
		setTimeout(function () {
			cartTriggerMenu.click();
		}, 1000);
	}
};

const initGalleryHover = () => {
	const gallery = $('#featured-recipes-spread');
	const galleryImageWrapper = $('#featured-recipes-spread .image-wrapper');
	const galleryImage = galleryImageWrapper.find('img');

	const processImage = (target, image) => {
		let show = true;
		target.mouseleave(function () {
			show = false;
		});

		setTimeout(function () {
			if (show) {
				galleryImage.attr('src', image);
			}
		}, 100);
	};

	_document.on(
		'mouseenter',
		'#featured-recipe-list .featured-article',
		function () {
			let _this = $(this);
			let thisImage = _this.data('src');
			processImage(_this, thisImage);
		}
	);
};

const initAccordion = () => {
	// for dropdowns which aren't accordions
	_document.on('click', '.dropdown:not(.expandable)', function (e) {
		// prevent bubbling of nested arrcordion clicks
		e.stopImmediatePropagation();
		let _this = $(this);

		_this.toggleClass('active');
		_this.attr('aria-expanded', _this.hasClass('active') ? 'true' : 'false');
		$('html').toggleClass('is-dropdown-active', _this.hasClass('active'));
		updateDropdownTabbing();
	});

	// for dropdowns which ARE accordions
	_document.on('click', '.expandable-trigger', function (e) {
		// prevent bubbling of nested arrcordion clicks
		e.stopImmediatePropagation();
		let _this = $(this).closest('.expandable');

		if (_this.hasClass('active')) {
			_this.removeClass('active');
			_this.attr('aria-expanded', 'false');
		} else {
			_this.addClass('active');
			_this.attr('aria-expanded', 'true');
		}

		updateDropdownTabbing();
	});

	// reverse direction of dropdown flyout once there's enough room for it to open downwards
	const dropdownInner = $('.dropdown-inner');

	if (dropdownInner.length > 0) {
		const dropdownInnerScroll = () => {
			if (scrollY > 300) {
				dropdownInner.addClass('reverse');
			} else {
				// Check if the parent '.dropdown' has 'is-reverse'
				if (!dropdownInner.parent('.dropdown').hasClass('is-reverse')) {
					dropdownInner.removeClass('reverse');
				}
			}
		};

		_window.scroll(function () {
			dropdownInnerScroll();
		});

		dropdownInnerScroll();
	}

	// close on outside click
	_document.click(function (e) {
		if (
			!$(e.target).hasClass('dropdown') &&
			!$('.dropdown').find(e.target).length
		) {
			$('.dropdown').removeClass('active').attr('aria-expanded', 'false');
			$('html').removeClass('is-dropdown-active');
			updateDropdownTabbing();
		}
	});

	on('body', 'click', '.accordion', (e) => {
		let accordion = e.target.closest('.accordion');
		accordion.classList.toggle('is-expanded');
		accordion.setAttribute(
			'aria-expanded',
			accordion.classList.contains('is-expanded')
		);
	});

	// a11y enhancements
	_document.on('keydown', '.dropdown', function (e) {
		const $dropdown = $(this);
		const $menu = $dropdown.find('.dropdown-inner');

		switch (e.key) {
			case ' ':
			case 'Enter':
				e.preventDefault();
				$dropdown.toggleClass('active');
				const isActive = $dropdown.hasClass('active');

				$dropdown.attr('aria-expanded', isActive ? 'true' : 'false');
				$('html').toggleClass('is-dropdown-active', isActive);
				updateDropdownTabbing();

				if (isActive) {
					$menu.find('a:not([disabled])').first().focus();
				}
				break;

			case 'Escape':
				if ($dropdown.hasClass('active')) {
					e.stopPropagation();
					$dropdown.removeClass('active');
					$dropdown.attr('aria-expanded', 'false');
					$('html').removeClass('is-dropdown-active');
					updateDropdownTabbing();
					$dropdown.focus(); // return focus to button
				}
				break;
		}
	});

	// close dropdown when focus leaves menu
	_document.on('focusin', function (e) {
		const $activeDropdown = $('.dropdown.active');
		if ($activeDropdown.length === 0) return;

		const $menu = $activeDropdown.find('.dropdown-inner');
		const isInsideMenu = $menu.has(e.target).length > 0;
		const isButton = e.target === $activeDropdown[0];

		if (!isInsideMenu && !isButton) {
			$activeDropdown.removeClass('active').attr('aria-expanded', 'false');
			$('html').removeClass('is-dropdown-active');
			updateDropdownTabbing();
		}
	});

	const updateDropdownTabbing = () => {
		$('.dropdown').each(function () {
			const isActive = $(this).hasClass('active');
			const $links = $(this).find('.dropdown-inner a');
			$links.attr('tabindex', isActive ? '0' : '-1');
		});
	};

	updateDropdownTabbing();
};

const initSlider = () => {
	let sliderWrapper = $('.slider-wrapper');
	//defaults
	let wrap = true;
	let drag = true;
	let autoPlay = false;
	let pauseOnHover = true;
	let buttons = false;
	let dots = false;
	let align = 'left';

	const createSlider = (
		target,
		wrap,
		drag,
		autoplay,
		pauseOnHover,
		buttons,
		dots,
		align
	) => {
		target.flickity({
			wrapAround: wrap,
			draggable: drag,
			autoPlay: autoplay,
			pageDots: dots,
			pauseAutoPlayOnHover: pauseOnHover,
			prevNextButtons: buttons,
			pageDots: dots,
			cellAlign: align,
		});
	};

	if (sliderWrapper != null && typeof sliderWrapper != 'undefined') {
		sliderWrapper.each(function () {
			let _this = $(this);
			let slider = _this.find('.slider');
			let slides = _this.find('.slide');
			let prev = _this.find('.btn-prev');
			let next = _this.find('.btn-next');
			let nav = _this.find('.slider-nav-item');
			let count;

			//all-purpose slider functions
			const initSliderHelpers = () => {
				let flkty = slider.data('flickity');

				prev.on('click', () => {
					slider.flickity('previous', true, false);
				});

				next.on('click', () => {
					slider.flickity('next', true, false);
				});

				slider.on('dragStart.flickity', () =>
					slider.find('.slide').css('pointer-events', 'none')
				);
				slider.on('dragEnd.flickity', () =>
					slider.find('.slide').css('pointer-events', 'all')
				);

				nav.on('click', function () {
					let index = $(this).index();
					slider.flickity('select', index);
				});

				slider.on('change.flickity', function (event, index) {
					$(nav[index]).addClass('active').siblings().removeClass('active');
					// if slider elem contains a video, play it
					if ($(slides[index]).find('video').length > 0) {
						$(slides[index]).find('video').get(0).play();
					}
				});
			};

			// pdps
			if (slider.hasClass('slider-product') || slider.hasClass('slider-dots')) {
				let dots = true;
				createSlider(
					slider,
					wrap,
					drag,
					autoPlay,
					pauseOnHover,
					buttons,
					dots,
					align
				);
				initSliderHelpers();
				_window.on('resize', () => {
					createSlider(
						slider,
						wrap,
						drag,
						autoPlay,
						pauseOnHover,
						buttons,
						dots,
						align
					);
				});
				// insgtagram
			} else if (slider.hasClass('slider-instagram')) {
				let cellAlign = 'left';
				createSlider(
					slider,
					wrap,
					drag,
					autoPlay,
					pauseOnHover,
					buttons,
					dots,
					align
				);
				initSliderHelpers();
				_window.on('resize', () => {
					createSlider(
						slider,
						wrap,
						drag,
						autoPlay,
						pauseOnHover,
						buttons,
						dots,
						align
					);
				});
				//default
			} else if (slider.hasClass('slider-split')) {
				const sliderNav = slider.find('.slider-split-left');
				const sliderContent = slider.find('.slider-split-right');

				const createSplitSlider = () => {
					sliderNav.flickity({
						wrapAround: true,
						draggable: false,
						prevNextButtons: false,
						pageDots: false,
						asNavFor: $('.slider-split-right'),
					});

					sliderContent.flickity({
						wrapAround: true,
						draggable: false,
						prevNextButtons: false,
						pageDots: false,
						rightToLeft: true,
					});
				};

				createSplitSlider();
				_window.on('resize', createSplitSlider);

				prev.on('click', () => {
					sliderContent.flickity('previous', true, false);
				});

				next.on('click', () => {
					sliderContent.flickity('next', true, false);
				});

				sliderContent.on('change.flickity', function (event, index) {
					sliderNav.flickity('select', index, true, false);
				});
			} else {
				createSlider(
					slider,
					wrap,
					drag,
					autoPlay,
					pauseOnHover,
					buttons,
					dots,
					align
				);
				initSliderHelpers();
				_window.on('resize', () => {
					createSlider(
						slider,
						wrap,
						drag,
						autoPlay,
						pauseOnHover,
						buttons,
						dots,
						align
					);
				});
			}
		});
	}
};

const initSliderVideo = () => {
	const sliderVideos = document.querySelectorAll('.slider video');

	if (sliderVideos.length > 0) {
		sliderVideos.forEach((video) => {
			video.addEventListener('click', function () {
				if (video.paused) {
					video.play();
				} else {
					video.pause();
				}
			});
		});
	}
};

const initImgZoom = (target) => {
	let img = target.closest('.image-wrapper').querySelector('img.img-original');
	let result = target
		.closest('.image-wrapper')
		.querySelector('.js-zoom-result');

	img.addEventListener(
		'mouseenter',
		() => {
			result.src = result.dataset.src;
		},
		{ once: true }
	);

	img.addEventListener('mousemove', (e) => {
		let posX = e.offsetX;
		let posY = e.offsetY;
		let posXPerc = (posX / img.offsetWidth) * 100;
		let posYPerc = (posY / img.offsetHeight) * 100;
		result.style.transformOrigin = `${posXPerc}% ${posYPerc}%`;
	});
};

// 3.0 GLOBAL FUNCTIONS

const initProduct = () => {
	const infoPanelLabels = $('.product-info-label');

	infoPanelLabels.click(function (e) {
		let _this = $(this);
		let infoPanel = _this.data('panel');
		$(`[data-panel="${infoPanel}"]`)
			.addClass('active')
			.siblings()
			.removeClass('active');
	});

	let lightbox = document.querySelector('.global-lightbox');
	let lightBoxImages = lightbox.querySelector('.lightbox-images');

	// lightbox actions
	let lightboxImagesSpans = lightBoxImages.querySelectorAll('.contain');
	let lightboxCountCurrent = lightbox.querySelector('.lightbox-count-current');
	let activeProductImage = '';
	let currentImage = '';

	function activeIndex(activeProductImage) {
		lightboxImagesSpans.forEach((image) => {
			image.classList.remove('is-active');
			activeProductImage.dataset.index == image.dataset.index
				? image.classList.add('is-active')
				: '';
			currentImage = lightbox.querySelector('.contain.is-active');
		});
		updateCount();
	}

	// assign total image count
	lightbox.querySelector('.lightbox-count-total').innerHTML =
		lightboxImagesSpans.length;

	function updateCount() {
		//update currentImage
		currentImage = lightbox.querySelector('.contain.is-active');
		// update lightbox count
		lightboxCountCurrent.innerHTML = `${
			Number(currentImage.dataset.index) + 1
		}`;
	}

	// previous & next page
	function nextImage(image) {
		const lastImg = image.parentNode.lastElementChild;
		const firstImg = image.parentNode.firstElementChild;
		if (image === lastImg) {
			firstImg.classList.add('is-active');
			image.classList.remove('is-active');
		} else {
			image.nextElementSibling.classList.add('is-active');
			image.classList.remove('is-active');
		}
		updateCount();
	}

	function prevImage(image) {
		const lastImg = image.parentNode.lastElementChild;
		const firstImg = image.parentNode.firstElementChild;
		if (image === firstImg) {
			lastImg.classList.add('is-active');
			image.classList.remove('is-active');
		} else {
			image.previousElementSibling.classList.add('is-active');
			image.classList.remove('is-active');
		}
		updateCount();
	}

	on('body', 'click', '[data-lightbox-trigger]', (e) => {
		let direction = e.target.closest('[data-lightbox-trigger]').dataset
			.lightboxTrigger;
		direction == 'prev' ? prevImage(currentImage) : nextImage(currentImage);
	});

	on('body', 'click', '.js-lightbox .image-wrapper', (e) => {
		if (isMobile) {
			// lightbox images are lazy so they cost nothing until it's opened
			lightbox.querySelectorAll('img[loading="lazy"]').forEach((img) => {
				img.loading = 'eager';
			});
			root.classList.add('lightbox-is-active');
			activeProductImage = document.querySelector(
				'.product-gallery .contain.is-selected'
			);
			activeIndex(activeProductImage);
		}
	});

	on('body', 'click', '.js-lightbox-close', (e) => {
		root.classList.remove('lightbox-is-active');
	});

	// Magnify image
	if (!isTablet) {
		document
			.querySelectorAll('.product-gallery .image-wrapper')
			.forEach((imgWrapper) => {
				initImgZoom(imgWrapper);
			});
	}
};

// 4.0 PAGE-SPECIFIC FUNCTIONS

const initAccounts = () => {
	const loginForm = $('#login-form');
	const recoverForm = $('#recover-form');
	const recoverFormTrigger = $('#recover-form-trigger');

	function recoverFormChange(e) {
		e.preventDefault();

		if (window.location.hash == '#recover') {
			loginForm.slideUp();
			recoverForm.slideDown();
		} else {
			loginForm.slideDown();
			recoverForm.slideUp();
		}
	}

	recoverFormTrigger.click(function () {
		location.hash = '#recover';
		recoverFormChange();
	});

	window.addEventListener('hashchange', recoverFormChange, false);

	// on window load, if has hash recover, trigger form
	if (window.location.hash == '#recover') {
		recoverFormTrigger.trigger('click');
	}

	$('.orders-list ul').click(function (e) {
		e.preventDefault();
		let order = $(this);

		order.toggleClass('active').siblings('.order-details').slideToggle(200);
		order.parent().siblings().children('ul').removeClass('active');
		order.parent().siblings().children('.order-details').slideUp(200);
	});
};

const initPizzaShuffle = () => {
	const pizzaLabels = $('.pizza-label');
	const pizzaBoxes = $('.pizza-box');
	const pizzaBadges = $('#pizza-boxes .badge');

	const description = $('#home-pizza-description');
	const link = $('#home-pizza-link');

	// init
	$(pizzaBoxes[0]).addClass('active');
	$(pizzaBadges[0]).addClass('active');

	pizzaLabels.click(function () {
		let _this = $(this);
		let index = _this.data('index');
		//set new nav active state
		_this.addClass('active').siblings().removeClass('active');
		//set new pizz state

		// js object from sections/home-pizza
		let newDescription = pizzaBlocks[index].description;
		let newLink = pizzaBlocks[index].link;
		let newCTA =
			pizzaBlocks[index].available == 'true'
				? `Shop ${pizzaLabels[index].innerText}`
				: `Learn More`;
		// temp override for just this product
		if (pizzaLabels[index].innerText == 'FOUR CHEESE') newCTA = 'Learn More';

		description.html(newDescription);
		link.attr('href', newLink);
		link.html(newCTA);

		pizzaLabels.removeClass('active');
		pizzaBoxes.removeClass('active');
		pizzaBadges.removeClass('active');
		$(pizzaLabels[index]).addClass('active');
		$(pizzaBoxes[index]).addClass('active');
		$(pizzaBadges[index]).addClass('active');
	});
};

const initAbout = () => {
	const sections = document.querySelectorAll('.js-about-section');
	const sectionButtons = document.querySelectorAll('.js-about-section-btn');
	const scrollThreshold = innerHeight / 2;
	let activeSection = 0;

	const updateSectionInView = () => {
		sections.forEach((section, sectionIndex) => {
			const rect = section.getBoundingClientRect();
			const isInView =
				rect.top <= scrollThreshold && rect.bottom > scrollThreshold;

			if (isInView) {
				activeSection = sectionIndex;
			}

			sectionButtons.forEach((btn, btnIndex) => {
				if (
					activeSection === btnIndex &&
					!btn.classList.contains('is-active')
				) {
					btn.classList.add('is-active');
				} else if (
					activeSection !== btnIndex &&
					btn.classList.contains('is-active')
				) {
					btn.classList.remove('is-active');
				}
			});
		});
	};

	window.addEventListener(
		'scroll',
		throttle(() => {
			updateSectionInView();
		}, 200)
	);

	// init
	updateSectionInView();
};

const initNutritionShuffle = () => {
	const nutrition = $('.nutrition');
	const nutritionLabels = $('.nutrition-toggle');
	const nutritionPanels = $('.nutrition-block');

	// for a/b testing
	if (location.hash == '#1') {
		nutrition.addClass('version-b');
	}

	nutritionLabels.click(function () {
		let _this = $(this);
		let index = _this.data('index');
		//set new nav active state
		_this.addClass('active').siblings().removeClass('active');
		//set new pizz state
		$(nutritionPanels[index])
			.addClass('active')
			.siblings()
			.removeClass('active');
	});
};

const initScrollTop = () => {
	const scrollTop = $('.btn-top');
	scrollTop.click(function () {
		$('html, body').animate({ scrollTop: 0 }, 1000);
	});
};

const initViewMore = () => {
	const paginateWrapper = document.querySelector('.paginate');
	const viewMoreButton = document.getElementById('view-more-button');
	const totalItemCount = document.querySelectorAll('[data-view-group]').length;
	const paginateBy = parseInt(paginateWrapper.getAttribute('data-paginate'));
	let viewGroup = 0;
	let itemTally = paginateBy * (viewGroup + 1);

	viewMoreButton.addEventListener('click', () => {
		viewGroup++;
		itemTally = paginateBy * (viewGroup + 1);
		let viewMoreItems = document.querySelectorAll(
			`[data-view-group="${viewGroup}"]`
		);
		if (viewMoreItems.length > 0) {
			viewMoreItems.forEach((item) => {
				item.style.display = 'inline-block';
			});
		}

		if (itemTally >= totalItemCount) {
			viewMoreButton.style.display = 'none';
		}
	});
};

// const initCareers = () => {
// 	$('#current-openings .expandable-trigger').click();
// 	if (getQueryVariable('gh_jid') != false) {
// 		setTimeout(() => {
// 			scrollToEl('#current-openings', 100)
// 		}, 1000)
// 	}
// };

const initReviews = () => {
	const ratingsSummary = document.getElementById('ratings-summary-wrapper');
	const ratingsMain = document.getElementById('product-reviews');
	let checks = 0;

	if (ratingsSummary && ratingsMain) {
		const isReviewWidgetLoaded = () => {
			// if the element loaded?
			checks++;
			// hide by default since reviews load async and unpredictably
			ratingsSummary.classList.add('hidden');
			ratingsMain.classList.add('hidden');

			// stop checking after 4s
			if (checks > 160) {
				clearInterval(reviewWidgetInterval);
			}
			// if both the summary and the full reviews have been found
			if (document.querySelector('#ratings-summary[aria-label]')) {
				// console.log('ratings-summary found, stop checking')
				// reviews are loaded (stop checking)
				clearInterval(reviewWidgetInterval);

				// console.log(document.querySelectorAll('.bv-write-review-label').length)
				// show reviews if there is no evidence of "be the first to write a review prompt"
				setTimeout(() => {
					if (
						document.querySelector(
							'#ratings-summary[aria-label*="No rating value"]'
						)
					) {
						// console.log('no reviews')
						document.getElementById('ratings-summary-wrapper').remove();
						document.getElementById('product-reviews').remove();
					} else {
						document
							.getElementById('ratings-summary-wrapper')
							.classList.remove('hidden');
						document
							.getElementById('product-reviews')
							.classList.remove('hidden');
					}
				}, 50);
			}
		};

		let reviewWidgetInterval = setInterval(isReviewWidgetLoaded, 25);
	}
};

class ComponentFaq extends HTMLElement {
	constructor() {
		super();

		const ACCORDION_PADDING = 30;
		this.activeHandle;
		this.faqs = {};
		this.contentWrapper = this.querySelector('.js-faq-wrapper');
		this.contentHeight = this.contentWrapper.clientHeight; // keep track of content height to adjust when accordions are opened & closed

		on('.js-faq', 'click', '.js-faq-btn', (e) => {
			const handle = e.target.closest('.js-faq-btn')?.dataset.handle;
			handle && this.updateActiveSection(handle);
		});

		// adjust wrapper height to ensure faqs don't overflow the section
		on('.js-faq', 'click', '.js-expand-accordion', (e) => {
			const accordion = e.target.closest('.accordion');
			setTimeout(() => {
				const diff =
					accordion?.querySelector('.js-accordion-content-height')
						?.scrollHeight + ACCORDION_PADDING;
				if (diff) {
					if (accordion.classList.contains('is-expanded')) {
						this.contentHeight += diff;
						this.contentWrapper.style.height = `${this.contentHeight}px`;
					} else {
						this.contentHeight -= diff;
						setTimeout(() => {
							this.contentWrapper.style.height = `${this.contentHeight}px`;
						}, 200);
					}
				}
			}, 10);
		});

		// init object mapping product handle to respective section elements + attributes
		this.querySelectorAll('.js-faq-content').forEach((content) => {
			const handle = content.dataset.handle;
			if (handle) {
				const button = this.querySelector(`.js-faq-btn[data-handle=${handle}]`);

				if (button) {
					this.faqs[handle] = {};
					this.faqs[handle].button = button;
					this.faqs[handle].content = content;
				}
			}
		});

		// initialize first section as active section
		this.updateActiveSection(Object.keys(this.faqs)[0]);

		window.addEventListener('resize', (e) => {
			this.updateWrapperHeight(this.faqs[this.activeHandle]?.content);
		});
	}

	updateActiveSection(handle) {
		if (!handle) return;

		if (this.activeHandle) {
			this.faqs[this.activeHandle]?.button.classList.remove('is-active');
			this.faqs[this.activeHandle]?.content.classList.remove('is-active');
		}

		if (this.faqs[handle]?.button && this.faqs[handle]?.content) {
			this.faqs[handle].button.classList.add('is-active');
			this.faqs[handle].content.classList.add('is-active');
			this.updateWrapperHeight(this.faqs[handle].content);
			this.activeHandle = handle;
		}
	}

	updateWrapperHeight(content) {
		if (!content) return;
		setTimeout(() => {
			this.contentHeight = content.clientHeight;
			this.contentWrapper.style.height = `${this.contentHeight}px`;
		}, 50);
	}
}
customElements.define('c-faq', ComponentFaq);
// ***END: ComponentFaq***

const initFAQSeach = () => {
	const faqEmpty = document.querySelector('.js-faq-empty');
	const faqGroupTitles = document.querySelectorAll('.js-faq-title');
	const faqItems = document.querySelectorAll('.js-accordion');
	const faqSearch = document.querySelector('.js-faq-search');
	const faqSearchInput = document.querySelector('.js-faq-search-bar');
	const categoryButtons = document.querySelectorAll('.js-faq-btn');
	const allCategoryButton = document.querySelector(
		'.js-faq-btn[data-handle="all"]'
	);

	if (!faqSearch) return;

	let filtered = false;
	let activeButtonIndex = 0;

	const resetFAQs = () => {
		faqEmpty.classList.add('is-hidden');

		faqGroupTitles.forEach((title) => {
			title.classList.remove('is-hidden');
		});
		faqItems.forEach((element) => {
			element.classList.remove('is-hidden');
		});
	};

	const handleSearch = (e) => {
		e.preventDefault();

		let searchQuery = formatHandleize(faqSearchInput.value);

		if (searchQuery && searchQuery.length > 1) {
			if (allCategoryButton) allCategoryButton.click();

			// hide titles
			faqGroupTitles.forEach((title) => {
				title.classList.add('is-hidden');
			});

			let count = 0;

			faqItems.forEach((item, i) => {
				const content = formatHandleize(item.innerText);
				if (content.includes(searchQuery)) {
					item.classList.remove('is-hidden');
					count++;
				} else {
					item.classList.add('is-hidden');
				}
			});

			if (count === 0) {
				faqEmpty.classList.remove('is-hidden');
			} else {
				faqEmpty.classList.add('is-hidden');
			}

			filtered = true;
		} else {
			filtered = false;
			resetFAQs();
			if (activeButtonIndex == 0) {
				allCategoryButton.click();
			}
		}
	};

	faqSearchInput.addEventListener('keyup', handleSearch);
	faqSearch.addEventListener('submit', handleSearch);

	on('body', 'click', '.js-faq-btn', (e) => {
		const button = e.target.closest('.js-faq-btn');
		const buttonIndex = [...categoryButtons].indexOf(button);

		if (buttonIndex != activeButtonIndex) {
			if (filtered == true) {
				faqSearchInput.value = '';
				resetFAQs();
			}
		}
		activeButtonIndex = buttonIndex;
	});

	// categoryButtonsArray.forEach((button) => {
	//     button.addEventListener("click", () => {
	//         // Get the index of the clicked button
	//         activeButtonIndex = categoryButtonsArray.indexOf(button);

	//         // Remove the active class from all buttons
	//         categoryButtonsArray.forEach((btn) => btn.classList.remove("is-active"));

	//         // Add the active class to the clicked button
	//         button.classList.add("is-active");

	//         console.log(`Active button index updated to: ${activeButtonIndex}`);
	//     });
	// });
};

const initBlogSearch = () => {
	// for blog search
	document.addEventListener('focusin', (e) => {
		if (e.target.matches('#blog-search input.search-input')) {
			root.classList.add('is-blog-search-active');
		}
	});

	document.addEventListener('focusout', (e) => {
		if (e.target.matches('#blog-search input.search-input')) {
			const related = e.relatedTarget;
			if (
				related &&
				(related.closest('.search-enter') ||
					related.classList.contains('search-enter'))
			) {
				return;
			}
			root.classList.remove('is-blog-search-active');
		}
	});
};

const initBlogFetch = () => {
	const blogContent = document.querySelector('.blog-content');
	const searchForm = document.querySelector('#blog-search');
	const searchInput = searchForm?.querySelector('input[name="q"]');

	if (!blogContent) return;

	const blogBaseUrl = window.location.pathname.split('/tagged/')[0];

	// Utilities
	const debounce = (fn, delay = 300) => {
		let timer;
		return (...args) => {
			clearTimeout(timer);
			timer = setTimeout(() => fn.apply(null, args), delay);
		};
	};

	const setLoading = (state) => {
		blogContent.classList.toggle('is-loading', state);
	};

	const updateBlogContent = (html) => {
		const doc = new DOMParser().parseFromString(html, 'text/html');

		const source =
			doc.querySelector('.blog-content') ||
			doc.querySelector('.search-results-wrapper');

		if (!source) {
			blogContent.innerHTML = '<p>Error loading content.</p>';
			return;
		}

		const hasWrapper = source.querySelector('#blog-results');

		blogContent.innerHTML = hasWrapper
			? source.innerHTML
			: `<div id="blog-results">${source.innerHTML}</div>`;

		if (!blogContent.querySelector('.article-card')) {
			blogContent.innerHTML =
				'<p class="blog-content__empty t-body-large cr-orange">No results found. Try a different search.</p>';
		}

		blogContent
			.querySelectorAll('img')
			.forEach((img) => img.classList.add('is-loaded'));

		initPageAnimation();
	};

	// Function to fetch blog content by URL and update grid
	const fetchBlogs = async (url, updateURL = true) => {
		try {
			setLoading(true);

			const res = await fetch(url, {
				headers: { 'X-Requested-With': 'XMLHttpRequest' },
			});

			if (!res.ok) throw new Error(res.status);

			updateBlogContent(await res.text());

			if (updateURL) {
				history.pushState(null, '', url);
			}
		} catch (err) {
			console.error('Fetch error:', err);
			blogContent.innerHTML = '<p>Failed to load content.</p>';
		} finally {
			setLoading(false);
		}
	};

	// Search handling
	if (searchForm && searchInput) {
		// Full submit → redirect
		searchForm.addEventListener('submit', (e) => {
			e.preventDefault();
			// const term = searchInput.value.trim();
			// if (!term) return;

			// window.location.href = `/search?type=article&view=articles&q=${encodeURIComponent(
			// 	term
			// )}`;
		});

		// Typing → async fetch
		searchInput.addEventListener(
			'input',
			// If search is empty, go back to main blog feed
			// If has text, go to search page
			debounce((e) => {
				const term = e.target.value.trim();
				const url = term
					? `/search?type=article&view=articles&q=${encodeURIComponent(term)}`
					: blogBaseUrl;

				fetchBlogs(url);
			}, 500)
		);
	}

	// Filter clicks
	document.addEventListener(
		'click',
		(e) => {
			const target = e.target.closest('.js-fetch');
			if (!target) return;

			e.preventDefault();
			e.stopImmediatePropagation();

			document
				.querySelectorAll('.js-fetch.is-active')
				.forEach((el) => el.classList.remove('is-active'));

			target.classList.add('is-active');

			const url = target.getAttribute('href');
			if (url) fetchBlogs(url);
		},
		true
	);
};

const initBlogPost = () => {
	document.querySelectorAll('.js-article img').forEach((img) => {
		const alt = img.getAttribute('alt');

		if (!alt) return;

		// Avoid double-processing
		if (img.closest('figure')) return;

		const figure = document.createElement('figure');
		const caption = document.createElement('figcaption');

		caption.textContent = alt;

		img.parentNode.insertBefore(figure, img);
		figure.appendChild(img);
		figure.appendChild(caption);
	});
};

$(document).ready(function () {
	initMobileNav();
	initPageTransition();
	initPageAnimation();
	initForms();
	initAccessibility();
	initNav();
	initCart();
	initSlider();
	initSliderVideo();
	initAccordion();
	download();

	switch (html.attr('id')) {
		case 'frontpage':
			initSlideshow();
			initPizzaShuffle();
			initGalleryHover();
			initNutritionShuffle();
			break;

		case 'product-single':
		case 'page-cascatelli':
			initProduct();
			// initReviews();
			break;

		case 'page-about':
			initAbout();
			initNutritionShuffle();
			break;

		case 'page-press':
			initViewMore();
			break;

		case 'page-faq':
			initFAQSeach();
			break;

		case 'blog-index':
			initScrollTop();
			initBlogSearch();
			initBlogFetch();
			break;

		case 'blog-single':
			initBlogPost();
			break;

		case 'accounts':
			initAccounts();
			break;
	}
});
